var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-text',{ref:"control",attrs:{"type":"textarea","maxlength":_vm.maxlength,"show-word-limit":_vm.showWordLimit,"novalidate":_vm.novalidate,"overflowWidth":_vm.overflowWidth,"nomessage":_vm.nomessage,"value":_vm.value,"required":_vm.required,"view":_vm.view},on:{"input":function($event){return _vm.$emit('input',$event);}}})
}
var staticRenderFns = []

export { render, staticRenderFns }